module.exports = __webpack_public_path__ + "media/images/products/retailers-og-4-672be226e4ecd39961d4bb9fbb7852cf.jpg";